<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de Prestação de contas">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/relatorio-prestacao-conta/List'

export default {
    components: { List },
}
</script>
